import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import { Coupon } from './store/coupon'
import { Home } from './store/home'
import { Detail } from './store/detail'
import { UseCoupon } from './store/useCoupon'
import { User } from './store/user'
import { Loading } from './store/loading'
import { Modal } from './store/modal'
import { Analytics } from './store/analytics'
import { Native } from './store/native'
import { Location } from './store/location'
import { FormRegisterUser } from './store/form-register-user'
import { Prize } from './store/prize'
import { Stamp } from './store/stamp'
import { Invitation } from './store/invitation'
import { Walk } from './store/walk'
import { Seal } from './store/seal'
import { SealPrefectures } from './store/sealPrefectures'
import { SealList } from './store/sealList'
import { PremiumTab } from './store/premium-tab'
import { LoginBonus } from './store/loginBonus'
import { ThirdPartyUid } from './store/third-party-uid'
import { AccountDelete } from './store/accountDelete'
import { SealTab } from './store/seal-tab'
import { CouponWithCart } from './store/couponWithCart'
import { Gacha } from './store/gacha'

Vue.use(Vuex)

let obj = {
  plugins: [],
  modules: {
    Coupon,
    Home,
    Detail,
    UseCoupon,
    Loading,
    Modal,
    User,
    Analytics,
    Native,
    Location,
    FormRegisterUser,
    Prize,
    Invitation,
    Stamp,
    Walk,
    Seal,
    SealPrefectures,
    SealList,
    PremiumTab,
    LoginBonus,
    ThirdPartyUid,
    AccountDelete,
    SealTab,
    CouponWithCart,
    Gacha,
   }
}
// if (process.env.NODE_ENV === 'production') {
// obj.plugins.push(createPersistedState({ key: 'quad-mypage' }))
// }
export const store = new Vuex.Store(obj)
